import { Component, Input, OnInit, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { TableMessages } from 'src/app/classes/table-options';
import { CommandRequestsService } from 'src/app/services/command-requests/command-requests.service';
import { HttpInterceptorService } from 'src/app/services/http-interceptor/http-interceptor.service';
import { UserType } from 'src/app/user-roles';
import { JsonViewerComponent } from '../../json-viewer/json-viewer.component';
import { ToastService } from '../../../shared/services/toast/toast.service';

@Component({
  selector: 'sc-box-responses',
  templateUrl: './box-responses.component.html',
  styleUrls: ['./box-responses.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BoxResponsesComponent implements OnInit {
  @Input() requestID: number;
  @Input() requestBoxID: number;
  @Input() request: any;

  prevRequestID: any;
  reqResponse: any = {};
  responses: any = [];
  loading: boolean = false;
  refreshing: boolean = false;
  checking: any;
  progress: number = 0;
  userType = UserType;
  tableMessages = new TableMessages();
  executing = false;
  canClickOnCustomer = false;

  constructor(
    private _http: HttpInterceptorService,
    private toastService: ToastService,
    private dialog: MatDialog,
    private cReqService: CommandRequestsService,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.initTableMessages();
  }
  ngOnDestroy() {
    clearInterval(this.checking);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.requestID || changes.requestBoxID) {
      const request = this.requestID
        ? this.cReqService.getResponsesByRequestID(this.requestID)
        : this.cReqService.getCommandRequestBoxID(this.requestBoxID);

      request.then((res) => {
        this.request = res;

        if (res.CanClickCustomer) {
          this.canClickOnCustomer = res.CanClickCustomer;
        }

        this.loadRequest();
      });
    }

    if (this.request) {
      this.loadRequest();
    }
  }

  loadRequest() {
    this.reset();
    this.loading = true;
    this.handleResponse(this.request);
    this.prevRequestID = this.request.PK_CommandRequestID;
    this.checking = setInterval(() => {
      this.getResponsesByRequestID();
    }, 2000);
  }

  initTableMessages() {
    const messages = new TableMessages();
    this.tableMessages.totalMessage = this.translate.instant(messages.totalMessage);
    this.tableMessages.emptyMessage = this.translate.instant(messages.emptyMessage);
    this.tableMessages.errorMessage = this.translate.instant(messages.errorMessage);
  }

  execute() {
    this.executing = true;

    this._http.get('Commands/ExecuteBatchTask/' + this.request.PK_CommandRequestID).subscribe((res) => {});
  }

  reset() {
    clearInterval(this.checking);
    this.reqResponse = {};
    this.responses = [];
    this.checking;
    this.progress = 0;
  }

  getProgress() {
    if (!this.reqResponse || !this.reqResponse.totalAnswers || !this.reqResponse.Boxes) return 0;

    let percent = (this.reqResponse.totalAnswers / this.reqResponse.Boxes.length) * 100;

    if (isNaN(percent)) this.progress = 0;
    this.progress = percent;
  }

  getResponsesByRequestID() {
    this.cReqService.getResponsesByRequestID(this.request.PK_CommandRequestID).then(
      (res) => {
        this.handleResponse(res);
      },
      (err) => {
        this.toastService.error(err);
        clearInterval(this.checking);
        this.loading = false;
        this.refreshing = false;
      }
    );
  }

  showParameters(parameters) {
    const dialogRef: MatDialogRef<JsonViewerComponent> = this.dialog.open(JsonViewerComponent, { width: '70vw' });
    dialogRef.componentInstance.json = parameters;
    dialogRef.componentInstance.title = 'Parameters';
  }

  handleResponse(requestRes) {
    if (!requestRes) return;

    this.loading = false;
    this.refreshing = false;
    this.reqResponse = this.cReqService.handleReqResponse(requestRes);
    //this.cReqService.handleReqResponse(requestRes);
    this.getProgress();
    if (this.reqResponse.totalAnswers === this.reqResponse.Boxes.length) {
      clearInterval(this.checking);
    }
  }

  checkStatus(response) {
    if (!response) return;

    status = '-';
    if (response.answer && !response.HasFailed) {
      status = 'COMPLETE';
    } else if (!response.answer) {
      status = 'PENDING';
    } else if (response.HasFailed) {
      status = 'FAILED';
    }
    return status;
  }

  showAnswer(ev) {
    if (ev && ev.type === 'click' && ev.row) {
      if (!ev.row.answer) return;

      let message;
      try {
        message = JSON.parse(ev.row.answer);
      } catch {
        message = ev.row.answer.replace(/,/g, ',\r\n');
      }

      if (!message) return;

      let dialogRef: MatDialogRef<JsonViewerComponent>;
      dialogRef = this.dialog.open(JsonViewerComponent, { width: '70vw' });
      dialogRef.componentInstance.json = message;
      dialogRef.componentInstance.title = this.reqResponse.type;
      dialogRef.componentInstance.date = ev.row.timeAnswer;
    }
  }
}
